import ReactECharts from "echarts-for-react";

const ReadClusterLineChart = ({
  xAxisData,
  yAxisData,
  legend,
}: {
  xAxisData: (string | number)[];
  yAxisData: (string | number)[];
  legend: string;
}) => {
  const options = {
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        rotate: 45,
        formatter: (value: any) => {
          return value;
        },
      },
      axisLine: { show: false },
      axisTick: { show: false },
      interval: 0,
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ddd",
          type: "dashed",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value: number) => `${value}`,
        color: "#5F6368",
        fontSize: 9,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ddd",
          type: "dashed",
        },
      },
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: (params: any) => {
        const value = Number(params[0].value);
        const formattedValue = !isNaN(value)
          ? value.toFixed(4)
          : params[0].value;
        return `
        <div style="padding: 5px; color: #fff;">
          ${params[0].name}: ${formattedValue}
        </div>
      `;
      },
    },
    grid: {
      left: "2%",
      right: "2%",
      bottom: "3%",
      containLabel: true,
    },
    legend: {
      data: [{ name: `${legend}`, icon: "roundRect" }],
      left: "12",
      top: "12",
      itemWidth: 15,
      itemHeight: 15,
      itemGap: 15,
      textStyle: {
        fontFamily: "Figtree",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11.72,
        letterSpacing: "0.02em",
        color: "#4C5269",
        textAlign: "left",
      },
      selectedMode: true,
    },
    series: [
      {
        name: `${legend}`,
        type: "line",
        data: yAxisData,
        smooth: true,
        lineStyle: { width: 1, color: "#1064ED" },
        itemStyle: { color: "#1064ED" },
        symbol: "none",
        emphasis: {
          disabled: true,
        },
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "100%", width: "100%" }} />
  );
};

export default ReadClusterLineChart;
